interface PaletteEntry {
  readonly bg: string;
  readonly text: string;
}

/** Hex palette used by OG avatars for deterministic identity colours. */
export const OG_AVATAR_PALETTE: readonly PaletteEntry[] = [
  { bg: '#64748b', text: '#ffffff' },
  { bg: '#6b7280', text: '#ffffff' },
  { bg: '#f97316', text: '#ffffff' },
  { bg: '#f59e0b', text: '#ffffff' },
  { bg: '#84cc16', text: '#ffffff' },
  { bg: '#10b981', text: '#ffffff' },
  { bg: '#14b8a6', text: '#ffffff' },
  { bg: '#06b6d4', text: '#ffffff' },
  { bg: '#0ea5e9', text: '#ffffff' },
  { bg: '#3b82f6', text: '#ffffff' },
  { bg: '#6366f1', text: '#ffffff' },
  { bg: '#8b5cf6', text: '#ffffff' },
  { bg: '#d946ef', text: '#ffffff' },
  { bg: '#ec4899', text: '#ffffff' },
] as const;

const NEUTRAL_FALLBACK: PaletteEntry = { bg: '#2f2f2f', text: '#a8a8a8' };

export function getOgAvatarInitials(displayName: string | null): string {
  if (displayName === null || displayName.length === 0) return 'AN';
  return Array.from(displayName).slice(0, 2).join('').toUpperCase();
}

export function resolveOgAvatarSeed(
  displayName: string | null,
  handle: string | null | undefined,
): string | null {
  if (typeof displayName === 'string' && displayName.length > 0) return displayName;
  if (typeof handle === 'string' && handle.length > 0) return handle;
  return null;
}

export function hashOgAvatarName(displayName: string): number {
  let sum = 0;
  for (let i = 0; i < displayName.length; i += 1) {
    sum = (sum + displayName.charCodeAt(i)) >>> 0;
  }
  return sum % OG_AVATAR_PALETTE.length;
}

export function getOgAvatarPaletteEntry(displayName: string | null): PaletteEntry {
  if (displayName === null || displayName.length === 0) return NEUTRAL_FALLBACK;
  return OG_AVATAR_PALETTE[hashOgAvatarName(displayName)] ?? NEUTRAL_FALLBACK;
}
